/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  // Superbrand Widget

(function () {
  window.superbrandBenefitVariantIds = {
    whiteGlove: 50251221958876,
    gift90: 40067493363871,
    gift150: 40067494314143,
    gift200: 45745667539164,
    gift300: 45745667670236
  };

  window.showFinanceWidget554689 = function (event) {
    if (event) event.preventDefault();

    try {
      if (typeof window.gsc === 'function') {
        window.gsc('show', 554689);
        return false;
      }
    } catch (e) {}

    window.location.hash = 'getsitecontrol?id=554689';
    return false;
  };

  function initSuperbrandBenefits() {
    var sections = document.querySelectorAll('[data-superbrand-benefits]');

    sections.forEach(function (section) {
      if (section.dataset.superbrandInitialised === 'true') return;
      section.dataset.superbrandInitialised = 'true';

      var giftCardValue = Number(section.dataset.giftCardValue);
      var benefitButtons = section.querySelectorAll('.superbrand-benefit-select');
      var confirmation = section.querySelector('[data-superbrand-confirmation]');
      var financeInitialised = false;

      function getGiftVariantId() {
        if (giftCardValue === 300) return window.superbrandBenefitVariantIds.gift300;
        if (giftCardValue === 200) return window.superbrandBenefitVariantIds.gift200;
        if (giftCardValue === 150) return window.superbrandBenefitVariantIds.gift150;
        if (giftCardValue === 90) return window.superbrandBenefitVariantIds.gift90;
        return null;
      }

      function getBenefitVariantId(type) {
        return type === 'white_glove'
          ? window.superbrandBenefitVariantIds.whiteGlove
          : getGiftVariantId();
      }

      function getAddedText(type, label) {
        if (type === 'white_glove') {
         return 'Great choice – complimentary white glove or Northern Ireland delivery will be added with this item.';
        }

        return 'Great choice – your ' + label + ' will be added with this item.';
      }

      function getDefaultButtonText(type) {
        if (type === 'white_glove') {
          return 'Add delivery';
        }

        return 'Add e-gift card';
      }

      function refreshCartUI() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('theme:cart:change'));

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true
        }));

        try {
          if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
            window.theme.cart.getCart();
          }
        } catch (e) {}
      }

      function resetCards() {
        benefitButtons.forEach(function (button) {
          var card = button.closest('.superbrand-benefit-card');
          var type = button.dataset.superbrandBenefit;

          button.classList.remove('is-selected');
          button.classList.remove('is-loading');
          button.textContent = getDefaultButtonText(type);
          button.style.opacity = '1';

          if (card) {
            card.classList.remove('is-selected');
          }
        });
      }

      function markSelected(button) {
        resetCards();

        var card = button.closest('.superbrand-benefit-card');
        var type = button.dataset.superbrandBenefit;
        var label = button.dataset.superbrandLabel;

        button.classList.add('is-selected');
        button.classList.remove('is-loading');
        button.textContent = 'Selected';
        button.style.opacity = '1';

        if (card) {
          card.classList.add('is-selected');
        }

        section.dataset.superbrandSelected = 'true';
        section.classList.remove('show-soft-message');

        if (confirmation) {
          confirmation.textContent = getAddedText(type, label);
          confirmation.classList.add('is-visible');
        }
      }

      function showSoftReminder() {
        if (section.dataset.superbrandSelected === 'true') return;

        section.classList.add('show-soft-message');
        section.classList.add('is-highlighted');

        window.setTimeout(function () {
          section.classList.remove('is-highlighted');
        }, 1400);
      }

      function removeExistingBenefits() {
        return fetch('/cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            var updates = {};

            cart.items.forEach(function (item) {
              if (
                item.variant_id === window.superbrandBenefitVariantIds.whiteGlove ||
                item.variant_id === window.superbrandBenefitVariantIds.gift90 ||
                item.variant_id === window.superbrandBenefitVariantIds.gift150 ||
                item.variant_id === window.superbrandBenefitVariantIds.gift200 ||
                item.variant_id === window.superbrandBenefitVariantIds.gift300
              ) {
                updates[item.key] = 0;
              }
            });

            if (Object.keys(updates).length === 0) {
              return Promise.resolve();
            }

            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ updates: updates })
            });
          });
      }

      function cartContainsVariant(variantId) {
        return fetch('/cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            return cart.items.some(function (item) {
              return Number(item.variant_id) === Number(variantId);
            });
          });
      }

      function directAddBenefitToCart(benefitVariantId) {
        window.location.href = '/cart/add?id=' + encodeURIComponent(benefitVariantId) + '&quantity=1&return_to=/cart';
      }

      function addBenefitToCart(button) {
        var type = button.dataset.superbrandBenefit;
        var label = button.dataset.superbrandLabel;
        var benefitVariantId = getBenefitVariantId(type);

        if (!benefitVariantId) {
          alert('Sorry, this complimentary benefit could not be identified.');
          return;
        }

        benefitButtons.forEach(function (btn) {
          btn.disabled = true;
        });

        button.textContent = 'Adding';
        button.classList.add('is-loading');
        button.style.opacity = '1';

        removeExistingBenefits()
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                id: Number(benefitVariantId),
                quantity: 1,
                properties: {
                  'Superbrand benefit': label,
                  '_Superbrand benefit add-on': 'true',
                  '_superbrand_hidden': 'true'
                }
              })
            });
          })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error(data.description || 'Benefit add failed');
              });
            }

            return response.json();
          })
          .then(function () {
            return cartContainsVariant(benefitVariantId);
          })
          .then(function (isInCart) {
            if (!isInCart) {
              directAddBenefitToCart(benefitVariantId);
              return;
            }

            markSelected(button);
            refreshCartUI();
          })
          .catch(function (error) {
            console.error('Superbrand benefit error:', error);

            /*
              Reliable fallback:
              If the AJAX route fails after the main product has already been added,
              use Shopify's direct add route and take the customer to the cart page.
            */
            directAddBenefitToCart(benefitVariantId);
          })
          .finally(function () {
            button.classList.remove('is-loading');

            benefitButtons.forEach(function (btn) {
              btn.disabled = false;
            });
          });
      }

      function initFinance() {
        if (financeInitialised || section.dataset.financeAvailable !== 'true') return;

        var financeUid = section.dataset.financeUid;
        var seg = document.getElementById(financeUid + '-seg');
        if (!seg) return;

        var indicator = seg.querySelector('.superbrand-finance__indicator');
        var buttons = seg.querySelectorAll('button');
        var termLabel = document.getElementById(financeUid + '-term');
        var paymentLabel = document.getElementById(financeUid + '-monthly');
        var terms = section.dataset.financeTerms.split(',').map(function (term) {
          return Number(term);
        });
        var maxIndex = terms.length - 1;
        var price = Number(section.dataset.financePrice);
        var productId = section.dataset.financeProductId;
        var storageKey = 'finance_term_index:' + productId;

        function readSavedIndex() {
          try {
            var value = window.localStorage.getItem(storageKey);
            var index = parseInt(value, 10);
            return Number.isFinite(index) && index >= 0 && index <= maxIndex ? index : null;
          } catch (e) {
            return null;
          }
        }

        function saveIndex(index) {
          try {
            window.localStorage.setItem(storageKey, String(index));
          } catch (e) {}
        }

        function setActive(index, shouldPersist) {
          if (index < 0) index = 0;
          if (index > maxIndex) index = maxIndex;

          var months = terms[index];

          if (indicator) {
            indicator.style.transform = 'translateX(' + index * 100 + '%)';
          }

          if (termLabel) {
            termLabel.textContent = months;
          }

          if (paymentLabel) {
            paymentLabel.textContent = '£' + (price / months / 100).toFixed(2);
          }

          buttons.forEach(function (button) {
            var isActive = parseInt(button.dataset.index, 10) === index;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-checked', isActive ? 'true' : 'false');
          });

          seg.setAttribute('data-active-index', index);

          if (shouldPersist) saveIndex(index);
        }

        var initialIndex = readSavedIndex();

        if (initialIndex === null) {
          initialIndex = Number(section.dataset.financeDefaultIndex || 0);
        }

        setActive(initialIndex, false);

        buttons.forEach(function (button) {
          button.addEventListener('click', function () {
            setActive(parseInt(button.dataset.index, 10), true);
          });

          button.addEventListener('keydown', function (event) {
            var index = parseInt(seg.getAttribute('data-active-index'), 10);

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              setActive(index + 1, true);
            }

            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              setActive(index - 1, true);
            }

            if (event.key === 'Home') {
              event.preventDefault();
              setActive(0, true);
            }

            if (event.key === 'End') {
              event.preventDefault();
              setActive(maxIndex, true);
            }
          });
        });

        financeInitialised = true;
      }

      function attachSoftAddToCartReminder() {
        var productForms = document.querySelectorAll('form[action*="/cart/add"]');

        productForms.forEach(function (form) {
          if (form.dataset.superbrandReminderAttached === 'true') return;
          form.dataset.superbrandReminderAttached = 'true';

          form.addEventListener('submit', function () {
            if (section.dataset.superbrandSelected !== 'true') {
              showSoftReminder();
            }
          });

          var submitButtons = form.querySelectorAll('[type="submit"], button[name="add"]');

          submitButtons.forEach(function (button) {
            button.addEventListener('click', function () {
              if (section.dataset.superbrandSelected !== 'true') {
                showSoftReminder();
              }
            });
          });
        });
      }

      benefitButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          addBenefitToCart(button);
        });
      });

      initFinance();
      attachSoftAddToCartReminder();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSuperbrandBenefits);
  } else {
    initSuperbrandBenefits();
  }

  document.addEventListener('shopify:section:load', initSuperbrandBenefits);
})();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();